import { render, staticRenderFns } from "./TTooltipButton.vue?vue&type=template&id=177607bf&"
import script from "./TTooltipButton.vue?vue&type=script&lang=ts&"
export * from "./TTooltipButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports